import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


export const getWelcome = createAsyncThunk(
    'home/add-welcomes',
    async (_, { rejectWithValue }) => {
        try {
            const welcomeData = await GET(API.GET_Welcome);
            return welcomeData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Thunk for getting Add banners
export const getWhat_We_Are = createAsyncThunk(
    'home/add-what_we_are',
    async (_, { rejectWithValue }) => {
        try {
            const whatweareData = await GET(API.GET_What_We_Are);
            return whatweareData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const getWhat_Media_Do = createAsyncThunk(
    'home/add-what_me_do',
    async (_, { rejectWithValue }) => {
        try {
            const whatmediadoData = await GET(API.GET_What_Media_Do);
            return whatmediadoData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


// Create the slice
const aboutusSlice = createSlice({
    name: "aboutus",
    initialState: {
        name: '',
        image: '',
        description: '',
        addWelcome: [],
        addWhatWeAre: [],
        addWhatMediaDo: [],
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder


        .addCase(getWelcome.pending, (state) => {
            state.status = 'loading';
            console.log('State after pending', state);
        })
        .addCase(getWelcome.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.addWelcome = action.payload?.data || [];
            console.log('State after fulfilled', state);
        })
        .addCase(getWelcome.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
            console.log('State after rejected', state);
        })

            .addCase(getWhat_We_Are.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getWhat_We_Are.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addWhatWeAre = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getWhat_We_Are.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })


            .addCase(getWhat_Media_Do.pending, (state) => {
                state.status = 'loading';
                console.log('State after pending', state);
            })
            .addCase(getWhat_Media_Do.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.addWhatMediaDo = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getWhat_Media_Do.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })
            
            
    },
});

export default aboutusSlice.reducer;


